import * as locationOnboardingConstants from 'Components/LocationOnboarding/constants';

export default (state = locationOnboardingConstants.DEFAULT_VAL, action) => {
    switch (action.type) {
        case 'SET_LOCATION_ONBOARDING_STATUS':
            return action.data;
        default:
            return state;
    }
};
